type HtmlMetaData = { preview?: string } & Record<string, unknown>;

interface HtmlCarryingAttachment {
  url?: string | string[];
  metaData?: HtmlMetaData | HtmlMetaData[];
}

const firstOf = <T>(value: T | T[] | undefined): T | undefined =>
  Array.isArray(value) ? value[0] : value;

// Legacy photo-shaped rows (pre html-canonical, WIL-996) keep the rendered preview in
// url[0] instead of metaData.preview. The save path drops url for html attachments, so
// without this the preview is lost on the first save.
export const extractMetaDataWithPreview = ({
  url,
  metaData
}: HtmlCarryingAttachment): HtmlMetaData | undefined => {
  const existingMetaData = firstOf(metaData);
  if (existingMetaData?.preview) {
    return existingMetaData;
  }

  const preview = firstOf(url);
  return preview ? { ...existingMetaData, preview } : existingMetaData;
};
